import BeaconAction from '@tencent/beacon-web-sdk';
import store from '@/store';

/*
 * @Description: 灯塔数据上报
 * @Author: erickuang
 * @Date: 2020-12-30 15:12:20
 * @LastEditor: erickuang
 * @LastEditTime: 2021-10-20 13:32:38
 */

export enum ReportEventCode {
  PV = 'creator_pv',
  InputInviteCode = 'input#invite_code',
}

let beaconInstance = {} as BeaconAction;

export const getBeaconInstance = () => beaconInstance;

export const initBeaconSDK = () => {
  const success = (e: any) => {
    console.log('Report one successful msg: ', e);
  };
  const fail = (e: any) => {
    console.log('Report one failed msg: ', e);
  };
  const { initialGlobalData } = store.state;
  const { device } = initialGlobalData;
  const beaconConfig = {
    appkey: '0WEB0EU28741XCQR',
    versionCode: '1.0.0',
    delay: 1500,
    onReportSuccess: success,
    onReportFail: fail,
    openid: initialGlobalData.userId,
    uploadUrl: '',
  };
  beaconInstance = new BeaconAction(beaconConfig);

  // 设置用户唯一ID
  beaconInstance.setOpenId(initialGlobalData.userId);
  beaconInstance.setUnionid(initialGlobalData.userId);

  // 添加额外上报数据
  beaconInstance.addAdditionalParams({
    system: device.system,
    deviceBrand: device.brand,
    systemVersion: device.systemVersion,
    deviceModel: device.model,
    manufacturer: device.manufacturer,
    versionCode: device.versionCode,
    deviceId: device.deviceId,
  });
};

export const report = function (eventCode: ReportEventCode, extraData: any = {}) {
  beaconInstance?.onDirectUserAction(eventCode, extraData);
};

export const reportPV = function () {
  report(ReportEventCode.PV);
};
